module.exports = __webpack_public_path__ + "static/media/main_background@small.5832ab06.png";